<template>
  <svg viewBox="0 0 64 64" :height="height" :width="width" xmlns="http://www.w3.org/2000/svg">
    <title>YPO Concierge</title>
    <path :class="['default-style', customClass]"
          d="M17.542,38.0337c-.8005-1.0893-1.2714-2.592-2.5861-2.5838-.6821.0028-.6488.8048-.54,1.3142a10.9293,10.9293,0,0,0,.4738,1.5451c2.3018,6.0672.5837,4.205,3.514,7.3534,2.7665,2.9732,4.9974,3.7741,9.2148,5.3539l.3843-.459c1.5293-1.6711,2.994-1.6225,5.2811-1.4058,3.0677.2913,4.0262,4.1876,1.95,5.07C30.2914,56.3264,23.9,52.6824,19.8458,50.87c4.6712,10.3051,15.247,12.1565,22.11,6.768,4.6721-3.6686,6.8411-11.04,8.4118-13.3262a13.35,13.35,0,0,0,3.0354-7.0368c.34-2.1262-2.769-2.6518-4.2958,1.5527.3106-3.1034,1.4014-5.9936,1.204-9.2249-3.12-.9824-8.2513-.12-14.7949-2.6458A30.7652,30.7652,0,0,1,24.8,19.9479c-4.0352.3187-6.338,3.0134-7.7651,5.9055C15.2878,29.3934,17.5017,34.2349,17.542,38.0337ZM13.0693,9.4329c-8.8862,9.2977-2.9431,18.2258-5.702,20.8258-3.0581,2.8827-2.6276,4.7-1.0431,9.351,1.45,4.2573,2.8031,7.4611,8.1289,6.3161,1.1007,4.5872,6.5649,12.0275,8.95,13.6735,12.061,8.3229,21.8552,1.7774,27.876-10.77,1.144-2.3842,9.3985-14.2876,2.0687-15.199,1.057-8.029,1.3384-14.1687-2.9825-19.93-7.2324-9.642-27.3879-8.8438-33.664-.2587-4.82,6.594-3.668,11.1966-3.2351,20.2868a12.6781,12.6781,0,0,1-.9876-2.2632c-1.6615-3.8074-1.7629.8139-1.6748-8.3221.175-18.21,26.5316-26.1035,39.9635-12.255a17.7362,17.7362,0,0,1,4.94,12.999l-.0581,7.5167c-.01,1.2625,2.7024,1.3391,2.85.2892C62.8884.3936,30.426-7.57,13.0693,9.4329Z"/>
  </svg>
</template>
<style lang="scss">
@import '../../common/styles/_colors.scss';
.default-style {
  fill-rule:evenodd;
}

.fill_white {
  fill: $white;
}

.fill_black {
  fill: $black;
}

.fill_ypo_blue {
  fill: $ypo-blue;
}

</style>
<script>
export default {
  name: 'IconYpoConcierge',
  props: {
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    customClass: {
      type: String,
      default: "fill_white",
    },
  },
};
</script>
